module.exports = __webpack_public_path__ + "static/img/04.0f2fe13e.jpeg";